import React from 'react'

function BookOpenIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      fill="none"
      viewBox="0 0 52 52"
    >
      <g filter="url(#filter0_d_18545_39271)">
        <rect width="48" height="48" x="2" y="1" fill="#fff" rx="10"></rect>
        <path
          stroke="#344054"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M26 34l-.1-.15c-.695-1.042-1.042-1.563-1.5-1.94a3.999 3.999 0 00-1.378-.737C22.453 31 21.827 31 20.575 31H19.2c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874C16 29.48 16 28.92 16 27.8v-8.6c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C17.52 16 18.08 16 19.2 16h.4c2.24 0 3.36 0 4.216.436a4 4 0 011.748 1.748C26 19.04 26 20.16 26 22.4M26 34V22.4M26 34l.1-.15c.695-1.042 1.042-1.563 1.5-1.94a3.999 3.999 0 011.378-.737C29.547 31 30.173 31 31.425 31H32.8c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C36 29.48 36 28.92 36 27.8v-8.6c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C34.48 16 33.92 16 32.8 16h-.4c-2.24 0-3.36 0-4.216.436a4 4 0 00-1.748 1.748C26 19.04 26 20.16 26 22.4"
        ></path>
        <rect
          width="47"
          height="47"
          x="2.5"
          y="1.5"
          stroke="#EAECF0"
          rx="9.5"
        ></rect>
      </g>
      <defs>
        <filter
          id="filter0_d_18545_39271"
          width="52"
          height="52"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="1"></feOffset>
          <feGaussianBlur stdDeviation="1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18545_39271"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_18545_39271"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  )
}

export default BookOpenIcon
